'use es6';

import I18n from 'I18n';
export const moneyDecimals = number => {
  const value = Math.round(number * 100) / 100;
  return this.suffixLastDecimal(value);
};
export const suffixLastDecimal = value => {
  if (/\.\d{1}$/.test(value)) {
    value += '0';
  }

  return value;
};
export const formatPercentage = value => {
  if (typeof value !== 'number' || value === Infinity) {
    return null;
  }

  let sign = '';

  if (value < 0) {
    sign = '-';
  }

  let formattedValue;
  const fixedVal = Math.abs(value).toFixed(1);

  if (fixedVal < 10 && fixedVal !== 0) {
    formattedValue = I18n.formatNumber(Math.abs(value), {
      strip_insignificant_zeros: false,
      precision: 1
    });
  } else {
    formattedValue = I18n.formatNumber(Math.abs(value.toFixed(0)));
  }

  return `${sign}${formattedValue}%`;
};
/**
 * Takes a quotient in the form of 1.xx (or -1.xx) and converts it to the
 * corresponding percentage, ie. 1.05 -> 5
 */

export const quotientToPercentage = (value, precision) => {
  if (typeof value !== 'number' || value === Infinity) {
    return null;
  }

  let sign = '';

  if (value < 1.0) {
    sign = '-';
  }

  const formattedValue = (Math.abs(value - 1.0) * 100).toFixed(precision);
  return `${sign}${formattedValue}`;
};
export const percentageToQuotient = percentage => {
  const quotient = percentage / 100 + 1.0;
  return quotient;
};
export const dollars = (value, currencySymbol = '$', precision = 2) => {
  if (typeof value !== 'number' || value === Infinity) {
    return null;
  }

  let sign = '';

  if (value < 0) {
    sign = '-';
  }

  return `${sign}${currencySymbol}${I18n.formatNumber(Math.abs(value), {
    precision,
    strip_insignificant_zeros: false
  })}`;
};